import { useContext } from "react";
import { HeaderContext } from "./Header";
const Hamburger = ({ show,className='', lineclassName='', ...rest }) => {
  const {open,setOpen} = useContext(HeaderContext);
  if (show===true||window.innerWidth<show) return ( 
    <button className={'hamburger '+(open?'open ': '')+className} onClick={()=>setOpen(!open)} {...rest} >
        <div className="ham-menu">
            <span className={"line "+lineclassName} style={{transform: open?'rotate(45deg)':'rotate(0)'}}></span>
            <span className={"line "+lineclassName}  style={{opacity: open?"0":"1"}}></span>
            <span className={"line "+lineclassName}  style={{transform: open?'rotate(-45deg)':'rotate(0)'}}></span>
        </div>
    </button>
  )
};

export default Hamburger;